<template>
    <div class="top-company-info">
      40000+企业部署商用 | 200+产品软著 | 广东省高新技术企业 | 重合同受信用企业 | 科技型中小企业 | 专精特新中小企业
    </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },

  methods: {},

  components: {},
};

</script>
<style >
.top-company-info {
  background-color: #F3FAFF;
  text-align: center;
  padding:11px 0;
  color:#404040;
  font-size: 16px;
  margin:0 auto;
  font-weight: 400;
}
</style>